export default "__VITE_ASSET__qvoCt12M__"